import {extractProps} from '@famly/mf_ts-utils_extract-props';

export const extractDataProps = <P extends Dictionary<string, any>>(props: P) => {
    return extractProps<P, 'data'>(props, 'data');
};
